import { render, staticRenderFns } from "./WalletDetailedCalculationTab.vue?vue&type=template&id=3ecb02ac&"
import script from "./WalletDetailedCalculationTab.vue?vue&type=script&lang=js&"
export * from "./WalletDetailedCalculationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports